import React from "react";
import loadable from "@loadable/component";

const ReactBusStops = loadable(() => import("@micado-digital/react-bus-stops/ReactBusStops"));

const BusStops = ({ downloadFile, lang }) => {
	return (
		<>
			<ReactBusStops
				facilityIDs={[47]}
				lang={lang}
				regions={[
					"altenmarkt-zauchensee",
					"eben",
					"filzmoos",
					"flachau",
					"flachauwinkl-kleinarl",
					"radstadt",
					"stjohann",
					"wagraub"
				]}
				sortArr={[
					"Flachau",
					"Wagrain",
					"Kleinarl",
					"St. Johann",
					"Radstadt",
					"Altenmarkt",
					"Zauchensee",
					"Eben im Pongau",
					"Filzmoos"
				]}
				towns={[
					"Flachau",
					"Wagrain",
					"Kleinarl",
					"St. Johann",
					"Radstadt",
					"Altenmarkt",
					"Zauchensee",
					"Eben im Pongau",
					"Filzmoos"
				]}
				downloadFile={downloadFile}
			/>
		</>
	);
};

export default BusStops;
